import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function TaskIndex() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/tasks/rambos');
  }, [location, navigate]);

  return <></>
}
